import { useFlags, useFbClient } from '@featbit/react-client-sdk';

export function useFeatureFlag(flagKey: string, defaultValue = false): boolean {
  const flags = useFlags();
  const value = flags[flagKey];

  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value === 'true';
  return defaultValue;
}

export function useFeatureFlagString(flagKey: string, defaultValue = ''): string {
  const flags = useFlags();
  const value = flags[flagKey];
  if (value === undefined || value === null) return defaultValue;
  return String(value);
}

export { useFbClient, useFlags };
